import { Formik } from "formik";

import type { Document } from "@contentful/rich-text-types";
import type { Header, Values } from "../../types";
import { getValidationSchema } from "../../utils/getValidationSchema";
import { Form } from "./components/form";
import { Wrapper } from "./components/wrapper";
import { ExtendedForm } from "./components/extended-form/ExtendedForm";
import { hasExtendedNewsletterForm } from "@lib/utils/loyalty";
import { getInitialValues } from "../../utils/getInitialValues";

type Props = {
    headers: Header;
    isPending: boolean;
    isSuccess: boolean;
    policyAgreement: Document;
    onSubmit: (values: Values) => Promise<void>;
};

export const SubscriptionForm = ({
    headers,
    isPending,
    isSuccess,
    policyAgreement,
    onSubmit,
}: Props) => {
    return (
        <Wrapper
            hasExtendedNewsletterForm={hasExtendedNewsletterForm}
            headers={headers}
            isSuccess={isSuccess}
        >
            <Formik
                validationSchema={getValidationSchema({
                    headers,
                    hasPolicyAgreement: Boolean(policyAgreement),
                    hasExtendedNewsletterForm,
                })}
                initialValues={getInitialValues({
                    hasExtendedNewsletterForm,
                    hasPolicyAgreement: Boolean(policyAgreement),
                })}
                onSubmit={onSubmit}
            >
                {() =>
                    hasExtendedNewsletterForm ? (
                        <ExtendedForm
                            isLoading={isPending}
                            policyAgreement={policyAgreement}
                            headers={headers}
                        />
                    ) : (
                        <Form
                            isLoading={isPending}
                            policyAgreement={policyAgreement}
                            headers={headers}
                        />
                    )
                }
            </Formik>
        </Wrapper>
    );
};
